import queryString from 'query-string';

export const getUrlSearchParams = (param) => {
  return queryString.parse(location.search)[param];
};

export const generateUrlSearchParams = (params) => {
  return queryString.stringify(params);
};
